module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external {"root":"BrowserFS","commonjs2":"browserfs","commonjs":"browserfs","amd":"browserfs"}
// module id = 9
// module chunks = 0